import React from "react";
import { Control, actions } from "react-redux-form";
import {
  Row,
  Col,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { compose, withHandlers } from "recompose";
import shortid from "shortid";
import { get, max } from "lodash";
import { NotificationManager } from "react-notifications";
import { Trans } from "react-i18next";
import {
  FormGroup,
  DatePicker,
  required,
  Page,
  onMount,
  withReload,
  withLocalForm,
} from "components/common";
import {
  withXeroErrors,
  LineItems,
  withContactSearch,
  Attachments,
  withDocumentRenderer,
  withOptions,
} from "components";
import { QuoteDocument } from "components/documents";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { formatDate } from "../../../services/util";
import moment from "moment";
import BackButton from "components/refactoring/BackButton";
import { ConvertToInvoiceButton, pickQuote, DocumentTypeMapping } from "./constants/ConvertToInvoiceButton";
import { filterAndValidateLineItems, getBlankLineItems } from "../../../components/LineItems";

let _EditQuote = ({
  item,
  LocalForm,
  onSubmit,
  xero,
  handleSave,
  dispatch,
  handleAttachmentsChanged,
  ContactSearch,
  XeroErrors,
  organisation,
  DocumentRenderer,
  DownloadDocument,
  EmailDocument,
  history,
  form,
  t,
  selectedOrganisation,
}) => {

  const viewLink = () => {
    const { QuoteID } = item;

    history.push(`/quotes/view/${QuoteID}`)
  };

  return (
    <div>
      <Page
        title={
          item.QuoteId
            ? t(`Edit Quote {{ QuoteNumber }}`, {
              QuoteNumber: item.QuoteNumber,
            })
            : t("Create New Quote")
        }
        translate={false}
      >
        <BackButton />
        <br />
        <XeroErrors />

        <DocumentRenderer component={QuoteDocument} selectedOrganisation={selectedOrganisation} />
        <div className="d-flex align-items-center">
          <div className="mx-auto" />
          {!!(item.QuoteID && item.Attachments) && (
            <Attachments
              xero={xero}
              onAttachmentsChanged={handleAttachmentsChanged}
              baseUrl={`quotes/${item.QuoteID}`}
              attachments={item.Attachments}
            />
          )}
          {!!item.QuoteID && <DownloadDocument className="ml-2 mr-2" />}
          {!!item.QuoteID && <EmailDocument type="QUOTE" item={item} />}
          {!!item.QuoteID && (
            <ConvertToInvoiceButton
              disabled={!form.$form.valid}
              color="success"
              size="sm"
              className="ml-2"
              item={item}
            />
          )}
          <div className="">
            <button
              type="button"
              className="btn-sm btn btn-primary"
              onClick={viewLink}>
              View Quote
            </button>
          </div>
        </div>
        <LocalForm
          onSubmit={onSubmit}
          validators={{
            Contact: { required },
            Date: { required },
          }}
        >
          <Row>
            <Col xs={false} md={6} className="pt-2 pb-2">
              <FormGroup label={t("Document Type")} model=".DocumentType">
                <Control.select model=".DocumentType" defaultValue={item.DocumentType}>
                  <option disabled selected value> ------- </option>
                  {Object.keys(DocumentTypeMapping).map((value, i) => (
                    <option key={value} value={value}>
                      {t(DocumentTypeMapping[value])}
                    </option>
                  ))}
                </Control.select>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={false} md={6}>
              <FormGroup label="To" model=".Contact" addControlClass={false} className="pt-2 pb-2" >
                <ContactSearch model=".Contact" style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
            </Col>
            <Col xs={false} md={6}>
              <FormGroup label="Status" className="pt-2 pb-2">
                <Control.text model=".Status" readOnly />
              </FormGroup>
            </Col>
            <Col xs={false} md={6} className="pt-2 pb-2">
              <FormGroup label="Date" model=".Date">
                <DatePicker model=".Date" className="form-control" />
              </FormGroup>
            </Col>
            <Col xs={false} md={6} className="pt-2 pb-2">
              <FormGroup label="Expiry Date" model=".ExpiryDate">
                <DatePicker model=".ExpiryDate" className="form-control" />
              </FormGroup>
            </Col>
            <Col xs={false} md={6} className="pt-2 pb-2">
              <FormGroup label="Quote #" model=".QuoteNumber">
                <Control.text
                  placeholder="QU-AUTO"
                  readOnly={!item.QuoteID}
                  updateOn="blur"
                  model=".QuoteNumber"
                />
              </FormGroup>
            </Col>
            <Col xs={false} md={6}>
              <FormGroup label="Reference" model=".Reference" className="pt-2 pb-2">
                <Control.text updateOn="blur" model=".Reference" />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup label="Title" model=".Title" className="pt-2 pb-2">
                <Control.textarea updateOn="blur" model=".Title" rows={2} style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
              <FormGroup label="Summary" model=".Summary" className="pt-2 pb-2">
                <Control.textarea updateOn="blur" model=".Summary" rows={3} style={{ backgroundColor: '#F4F7FE' }} />
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <LineItems
            organisation={organisation}
            item={item}
            dispatch={dispatch}
            xero={xero}
            includeDiscount
            isNewInvoice={item.QuoteID ? false : true}
          />
          <FormGroup label="Terms" model=".Terms" className="pt-2 pb-2">
            <Control.textarea updateOn="blur" model=".Terms" rows={3} style={{ backgroundColor: '#F4F7FE' }} />
          </FormGroup>
          <div className="tw-flex tw-justify-end">
            <UncontrolledButtonDropdown>
              <Button color="primary" onClick={() => handleSave()}>
                <Trans>Save</Trans>
              </Button>
              <DropdownToggle caret color="primary" />
              <DropdownMenu>
                <DropdownItem onClick={() => handleSave()}>
                  <Trans>Save (continue editing)</Trans>
                </DropdownItem>
                <DropdownItem onClick={() => handleSave({ addAnother: true })}>
                  <Trans>Save & add another</Trans>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        </LocalForm>
      </Page>
    </div>
  );
};

const enhance = compose(
  withOrganisationContextConsumer,
  withReload(),
  onMount(({ match, xero, location, fetchOrganisation }) => async () => {
    const { id } = match.params;
    let item = null;

    if (id === "new") {
      item = get(location, "state.copy") || {
        DocumentType: "quotation",
        Contact: null,
        Date: formatDate(moment()),
        LineItems: getBlankLineItems(),
        LineAmountTypes: "Exclusive",
        Status: "DRAFT",
        ExpiryDate: "",
        CurrencyCode: null,
        QuoteNumber: "",
        Reference: "",
        Title: "",
        Summary: "",
        Terms: "",
      };
    } else {
      item = xero
        .get(`quotes/${match.params.id}`)
        .get("data")
        .then((item) => ({
          ...item,
          LineAmountTypes: {
            EXCLUSIVE: "Exclusive",
            INCLUSIVE: "Inclusive",
            NONE: "NoTax",
          }[item.LineAmountTypes],
          LineItems: item.LineItems.map((i) => {
            const line_amount = (i.LineAmount + i.TaxAmount)
            const unit_amount = line_amount / (1 - (i.DiscountRate ?? 0) / 100) / max([i.Quantity, 1])
            return {
              ...i,
              _id: shortid(),
              LineAmount: item.LineAmountTypes === 'INCLUSIVE' ? line_amount : i.UnitAmount,
              UnitAmount: item.LineAmountTypes === 'INCLUSIVE' ? unit_amount.toFixed(4) : i.UnitAmount,

            }
          }),
        }));
    }

    return Promise.props({
      item,
      organisation: fetchOrganisation(),
    });
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withContactSearch(),
  withXeroErrors(),
  withHandlers({
    handleAttachmentsChanged:
      ({ xero, match, dispatch }) =>
        () => {
          xero
            .get(`quotes/${match.params.id}/attachments`)
            .get("data")
            .tap((d) => dispatch(actions.change("local.Attachments", d)));
        },
    handleSave:
      ({ item, xero, history, match, setXeroErrors, reload, t, form, dispatch }) =>
        ({ addAnother } = {}) => {
          if (!form.$form.valid) return;

          const { result: LineItems, error } = filterAndValidateLineItems(
            dispatch
          )(item.LineItems);

          if (error) {
            return;
          }

          setXeroErrors(null);
          const { QuoteID } = item;

          const allowedItem = pickQuote(item);

          const p = QuoteID
            ? xero.put(`quotes/${QuoteID}`, {
              ...allowedItem,
              LineItems,
            })
            : xero.post("quotes", {
              ...allowedItem,
              LineItems,
            });

          p.then(({ data: { QuoteID } }) => {
            NotificationManager.success(t("Quote saved successfully"));

            if (addAnother) {
              history.push(match.path.replace(":id", "new"));
            } else {
              history.replace(`/quotes/view/${QuoteID}`);
            }
            reload();
          }, setXeroErrors);
        },
  }),
  withOptions(),
  withDocumentRenderer({
    onDownload:
      ({ item }) =>
        (getDocument) =>
          getDocument(
            {
              item,
            },
            `quote_${item.QuoteNumber}.pdf`
          ),
    type: "QUOTE",
  })
);

export const EditQuote = enhance(_EditQuote);
